module.exports = ".d3-chart {\n    width: 100%;\n    min-height: 400px;\n    height: 100%;\n}\n.d3-chart .axis path, .d3-chart .axis line {\n    stroke: #999;\n}\n.d3-chart .axis text {\n    fill: #999;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/bars/bars.component.css
// module id = ./src/app/chart/bars/bars.component.css
// module chunks = main